import React, { FC, useEffect, useState } from 'react'
import { ApiResponse, RouteSummary } from './model/Pegadaian.types'
import axiosInstance from './api/axiosInstance'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useNavigate } from 'react-router-dom'

const PegadaianTableRute: FC = () => {
  const navigate = useNavigate() // ✅ pindah ke dalam component

  const [routes, setRoutes] = useState<RouteSummary[]>([])
  const [loading, setLoading] = useState(false)

  const fetchSummary = async () => {
    try {
      setLoading(true)
      const res = await axiosInstance.get<ApiResponse>(
        '/rsvm/api/rsvm-booking/v1/report/summary-by-route'
      )
      setRoutes(res.data.data)
    } catch (error) {
      console.error(error)
      alert('Gagal mengambil data')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
  // pertama kali load
  fetchSummary()

  // set interval 20 detik
  const interval = setInterval(() => {
    fetchSummary()
  }, 20000) // 20.000 ms = 20 detik

  // cleanup biar nggak double interval
  return () => clearInterval(interval)
}, [])


  const handleBack = () => {
    navigate('/mudik-bersama/pegadaian')
  }

  return (
    <div className='container-xxl p-0'>
      <div className='row justify-content-center mx-0'>
        <div
          className='col-12 col-md-8 col-lg-5 p-0 bg-white pb-10 mx-auto'
          style={{ position: 'relative' }}
        >
          {/* HEADER */}
          <div
            className='position-relative w-100 overflow-hidden'
            style={{ borderEndEndRadius: 20, borderEndStartRadius: 20 }}
          >
            <img
              src={toAbsoluteUrl('/img/pegadaian-bg.png')}
              alt='Background'
              className='w-100 d-block'
              style={{
                height: 'clamp(90px, 14vw, 130px)',
                objectFit: 'cover',
              }}
            />

            {/* Overlay Header Content */}
            <div
              className='position-absolute top-0 start-0 w-100 d-flex align-items-center justify-content-between'
              style={{
                padding: 'clamp(14px, 4vw, 24px)',
              }}
            >
              {/* LEFT - BACK BUTTON */}
              <button
                onClick={handleBack}
                className='btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center'
                style={{
                  width: 42,
                  height: 42,
                }}
              >
                <KTIcon className='fs-3' iconName='arrow-left' />
              </button>

              {/* RIGHT - LOGO */}
              <img
                src={toAbsoluteUrl('/img/pegadaian-logo.png')}
                alt='pegadaian'
                style={{
                  height: 'clamp(28px, 5vw, 36px)',
                  objectFit: 'contain',
                }}
              />
            </div>
          </div>

          {/* CONTENT */}
          <div className='p-4'>
            <h4 className='fw-bold mb-4 text-success'>
              Summary Booking Rute
            </h4>

            {loading && <p>Loading...</p>}

            {!loading &&
              routes.map((item) => (
                <div
                  key={item.routeId}
                  className='card shadow-sm border-0 mb-3'
                  style={{
                    borderRadius: 16,
                    background: 'linear-gradient(135deg, #ffffff, #f8fff6)',
                  }}
                >
                  <div className='card-body'>
                    <div className='fw-bold text-dark mb-2'>
                      {item.origin} ➜ {item.destination}
                    </div>

                    <div className='d-flex justify-content-between'>
                      <div>
                        <div className='text-muted small'>Total Booking</div>
                        <div className='fw-bold fs-5 text-success'>
                          {item.totalBooking}
                        </div>
                      </div>

                      <div>
                        <div className='text-muted small'>Total Peserta</div>
                        <div className='fw-bold fs-5 text-primary'>
                          {item.totalPeserta}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            {!loading && routes.length === 0 && (
              <div className='text-center text-muted mt-4'>
                Tidak ada data
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PegadaianTableRute